export enum Titles {
  Mr = 'Mr.',
  Mrs = 'Mrs.',
  Ms = 'Ms.',
}
